import React from 'react'
import clsx from 'clsx'
import Breadcrumb from '@/v3-dashboard/components/UI/Breadcrumb'
import MainTitle from '@/v3-dashboard/components/UI/MainTitle'

const PageHeader = ({
  // Breadcrumb props
  breadcrumbItems = [],
  breadcrumbClassName = '',
  
  // MainTitle props
  title = '',
  titleClassName = '',
  titleTextClassName = '',
  titleIcon,
  titleOnClick,
  titleIsLoading = false,
  titleChildren,
  // Container props
  className = '',
  showBreadcrumb = true,
  showTitle = true,
  rightContent,
}) => {
  const hasRightContent = !!rightContent

  return (
    <div className={clsx(
      'mt-v3-md',
      'pb-v3-sm',
      'w-full',
      className
    )}>
      <div>
        {showBreadcrumb && (
          <Breadcrumb 
            items={breadcrumbItems} 
            className={breadcrumbClassName}
          />
        )}
        <div className='flex flex-row justify-between items-center gap-v3-md w-full'>
        {showTitle && ( <div className='flex items-center gap-v3-xs min-w-0 flex-1'>
          <MainTitle 
            Maintitle={title}
            className={titleClassName}
            MaintitleClassName={titleTextClassName}
            Icon={titleIcon}
            onClick={titleOnClick}
            isLoading={titleIsLoading}
          />
          {titleChildren}
        </div>)}
          {hasRightContent && (
            <div className={clsx(
              'flex gap-v3-xs',
              'w-auto',
            )}>
              {rightContent}
            </div>
          )}
        </div>
      </div>
    
    </div>
  )
}

export default PageHeader

